var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReservaRechazada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 66,
    fill: "none",
    viewBox: "0 0 70 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF16B",
    d: "M70 27.981v32.085c0 .566-.08 1.115-.232 1.633H.232C.081 61.18 0 60.632 0 60.066V27.981C0 26.96.264 26 .727 25.162l34.363.178 34.363.176c.352.75.547 1.585.547 2.465z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD845",
    d: "M70 27.981v32.085c0 .566-.081 1.115-.233 1.633H35.09v-36.36l34.363.177c.351.75.547 1.585.547 2.465z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD845",
    d: "M69.452 25.516l-11.338 11.05-23.024 7.396-22.87-7.307L.726 25.162c.995-1.8 2.913-3.021 5.111-3.021H64.16c2.34 0 4.363 1.383 5.292 3.375z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB454",
    d: "M69.453 25.516l-11.338 11.05-23.025 7.396V22.141h29.07c2.34 0 4.363 1.383 5.293 3.375z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E95772",
    d: "M58.116 5.62v30.945L46.317 48.063c-.383.374-.895.583-1.431.583H25.06c-.542 0-1.065-.216-1.449-.6L12.221 36.654V5.621C12.22 2.52 14.743 0 17.843 0h34.652c3.1 0 5.62 2.521 5.62 5.62z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E32B4D",
    d: "M58.115 5.62v30.945l-11.8 11.498c-.382.374-.895.583-1.43.583H35.09V0h17.404c3.1 0 5.62 2.521 5.62 5.62z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.942 26.535c.801.802.801 2.1 0 2.902-.4.399-.924.6-1.45.6-.524 0-1.05-.201-1.45-.6l-5.952-5.954-5.955 5.954c-.4.4-.925.601-1.45.601-.525 0-1.049-.2-1.45-.601-.8-.8-.8-2.099 0-2.9l5.955-5.954-5.953-5.953c-.801-.801-.801-2.099 0-2.9.8-.801 2.099-.801 2.9 0l5.953 5.953 5.954-5.954c.8-.801 2.1-.801 2.9 0 .8.801.8 2.098 0 2.9l-5.955 5.954 5.953 5.952z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD845",
    d: "M69.768 61.698c-.709 2.428-2.954 4.207-5.607 4.207H5.839c-2.653 0-4.898-1.779-5.607-4.207L33.82 38.083c.38-.267.827-.391 1.27-.372.383.018.762.14 1.09.372l33.588 23.615z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7FFFF",
    d: "M41.043 29.437l-5.953-5.954v-5.8l5.954-5.954c.801-.801 2.1-.801 2.9 0 .8.801.8 2.098 0 2.9l-5.954 5.954 5.952 5.952c.802.802.802 2.1 0 2.902-.399.399-.924.6-1.449.6s-1.05-.201-1.45-.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB454",
    d: "M69.767 61.698c-.708 2.428-2.953 4.207-5.607 4.207H35.09V37.711c.383.018.761.14 1.09.372l33.587 23.615z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReservaRechazada);
export default __webpack_public_path__ + "static/media/icon_reserva_rechazada.374b89f23cda6f73b45f75afc8271d0d.svg";
export { ForwardRef as ReactComponent };